<template>
    <div>
        <Header @update="update" :totalCount="totalCount"/>
        <div class="text-right"><b>Total Scripts:</b> {{ totalCount }}</div>
        <b-table :items="scripts" :fields="fields" :busy="isLoading" show-empty bordered striped head-variant="dark" style="text-align: left" @row-clicked="showAppDetails">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading..</strong>
            </div>
          </template>
          <template #empty>
            <div class="text-center text-danger my-2">
                No data found
            </div>
          </template>
            
          <template #cell(name)="row" >
            <div style="width: 200px; ">
              <div style="  display: flex;">
                <div style="padding-bottom: 0.5rem;" class="truncate"><b class="toCapitalFirst" >{{ row.item.name }}</b></div>                
              </div>
            <div >Ver. {{row.item.version ? row.item.version : 1}}</div>
            </div>
          </template>
  
          <template #cell(submittedOn)="row" >
           <div style="min-width: 100px; ">
             {{formatTime(row.item.submittedOn)}}
           </div>
          </template>
  
          <template #cell(changeLog)="row">
            <div style="min-width: 200px;max-width: 400px;" >
              <div class="w-full flex truncate">
                {{ row.item.changeLog ? row.item.changeLog  : "-" }}         
           
              </div>
            </div>
          </template>

          <template #cell(sla)="row">
            <div style="min-width: 100px; ">
                {{ row.item.sla ? row.item.sla + "Days" : getSLA(row.item.submittedOn) }} 
            </div>
          </template>
  
          <template #cell(status)="row">
            <div style="min-width: 100px;">
              <div v-if="row.item.status ==='disapproved'" class="tag danger"> Disapproved</div>              
              <div v-else-if="row.item.status ==='approved'" style="padding-bottom: 0.5rem; "><div class="tag success" > Approved</div></div>              
              <div v-else  class="tag warning"> Pending Review</div>
            </div>
            <div>{{ formatTime(row.item.approvedOn || row.item.disapprovedOn) }}</div>            
          </template>
        </b-table>
        
    </div>
</template>
  
<script>
import * as moment from "moment";
import { OAuthService } from "@/services"
import { ReviewStatus } from "@/constants/Oauth.ts"
import Header from "@/components/marketplace/marketplaceAppsReviewPortal/Header.vue";
require('../style.css')

export default {
    components:{Header},
    data() {
      return {
        fields: [
          {key: 'name', label: 'Name', sortable: true},
          {key: 'submittedOn', label: 'Submitted on', sortable: true},
          {key: 'changeLog', label: 'Change Log'},
          {key: 'sla', label: 'SLA'},
          {key: 'status', label: 'Status'}
        ],
        isLoading:false,
        totalCount:0,
        scripts:[]
      }
    },
    async mounted() {
        await this.update()
    },
    methods: {
        async fetchData(){
          try {
            this.isLoading = true;
            let query = {
                skip: this.skip,
                limit: this.limit
            }
            if(this.status){
                query['status'] = this.status
            }
            if(this.searchText !==''){
                query['query'] = this.searchText
            }
            this.scripts =[]
            const response = await OAuthService.Client.Review.getScriptsForReview(query)
            this.scripts = response.data.scripts || []  
            this.totalCount = response.data.count || 0                  
          } catch(error){
            console.error(error);
            alert(error.message || error.message[0] || "Something went wrong");
          }finally{
            this.isLoading = false
          }
        },
        async update(limit= 20, skip= 0, status= ReviewStatus.IN_REVIEW, searchText=''){
         this.status = status
         this.limit = limit
         this.skip = skip
         this.searchText = searchText
         await this.fetchData()
        },
      formatTime(time){
        return time ? moment(time).format(
          "MMM DD, YYYY"
        ):""
      },
      showAppDetails(item, index, event){
        this.$router.push(`/marketplace-apps-review/customScript/${item.customScriptId}?type=${this.status}`)
      },
      getSLA(d){
        if(d){
         const diff = Math.ceil((new Date().getTime() - new Date(d).getTime())/(1000*3600*24))
        return diff + " Days"
        }
        return "-" 
      }
    }
};
</script>
